import type {Page, Provider} from '@github-ui/command-palette'
import type {ClientDefinedProviderElement} from '../client-defined-provider-element'
import type {ProviderElement} from '../provider-element'
import type {ServerDefinedProviderElement} from '../server-defined-provider-element'

type PageProps = {
  title: string
  scopeId: string
  scopeType: string
}

export class GlobalProvidersPage implements Page {
  title: string
  scopeId: string
  scopeType: string

  constructor(data: PageProps) {
    this.title = data.title
    this.scopeId = data.scopeId
    this.scopeType = data.scopeType
  }

  get providers(): Provider[] {
    const providers = []
    for (const providerElement of this._providerElements) {
      if (providerElement.provider) {
        providers.push(providerElement.provider)
      }
    }
    return providers
  }

  get _providerElements(): ProviderElement[] {
    return [...this.serverDefinedProviderElements, ...this.clientDefinedProviderElements]
  }

  get serverDefinedProviderElements(): ServerDefinedProviderElement[] {
    const providerElements = document.querySelectorAll<ServerDefinedProviderElement>('server-defined-provider')
    return Array.from(providerElements)
  }

  get clientDefinedProviderElements(): ClientDefinedProviderElement[] {
    const providerElements = document.querySelectorAll<ClientDefinedProviderElement>('client-defined-provider')
    return Array.from(providerElements)
  }
}
